import React, { useState, useEffect, useCallback } from "react";
import { RightIcon } from "components/icons";
import clsx from "clsx";

type ScrollNavigationProps = {
  scrollContainerRef: React.RefObject<HTMLDivElement | null>;
  children: React.ReactNode;
  scrollDistance: number; // New prop for dynamic scroll distance
  className?: string;
  navLength?: number;
};

export const ScrollNavigation: React.FC<ScrollNavigationProps> = ({
  scrollContainerRef,
  children,
  scrollDistance,
  className,
  navLength,
}) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  // 检查是否需要显示左右箭头
  const checkOverflow = useCallback(() => {
    if (scrollContainerRef.current) {
      const { scrollWidth, clientWidth, scrollLeft } =
        scrollContainerRef.current;
      const hasOverflow = scrollWidth > clientWidth;
      setShowLeftArrow(hasOverflow && scrollLeft > 0);
      setShowRightArrow(hasOverflow && scrollLeft + clientWidth < scrollWidth);
    }
  }, [scrollContainerRef]);

  // 向右滑动指定的距离
  const handleScrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: scrollDistance,
        behavior: "smooth",
      });
    }
  };

  // 向左滑动指定的距离
  const handleScrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -scrollDistance,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkOverflow();
  }, [navLength, checkOverflow]);

  const handleScroll = () => {
    checkOverflow();
  };

  return (
    <div
      className={clsx(
        "relative flex flex-row items-center flex-1 overflow-hidden"
      )}
    >
      {showLeftArrow && (
        <button
          onClick={handleScrollLeft}
          className="absolute left-0 w-[26px] h-[26px] bg-white rounded-full flex items-center justify-center shadow-md hover:bg-gray-100 transition-colors z-10"
        >
          <span className="rotate-180">
            <RightIcon />
          </span>
        </button>
      )}

      <div
        onScroll={handleScroll}
        ref={scrollContainerRef}
        className={clsx(
          "flex flex-row items-center flex-1 overflow-x-auto",
          className,
          {
            // "mx-7": showLeftArrow || showRightArrow,
            "ml-7": showLeftArrow,
            "mr-7": showRightArrow,
          }
        )}
      >
        {children}
      </div>

      {showRightArrow && (
        <button
          onClick={handleScrollRight}
          className="absolute right-[0px] w-[26px] h-[26px] bg-white rounded-full flex items-center justify-center shadow-md hover:bg-gray-100 transition-colors z-10"
        >
          <RightIcon />
        </button>
      )}
    </div>
  );
};
